import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions')({
  beforeLoad: () => getTitleContextSlice('Risk360 Backoffice Actions'),
  staticData: {
    owner: CodeOwner.FabricAppsPlatform,
  },
});
